import React, { useState, useEffect } from "react"
import { Col, Row, Form } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import Navbar from "../../Components/Navbar/Navbar"
import Table from "../../Components/TableTemplate/Table"
import { getStatementsOfAccount } from "../../Helpers/apiCalls/StatementOfAccount/StatementOfAccountApi"

export default function StatementOfAccount() {
  const navigate = useNavigate()

  const [inactive, setInactive] = useState(true)
  const [showLoader, setShowLoader] = useState(false)
  const [data, setData] = useState([]) // raw list
  const [searchText, setSearchText] = useState("")

  // the per-row Action dropdown
  function ActionBtn(row) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action form-select"
        onChange={(e) => handleSelectChange(e, row)}
        value={""}
      >
        <option selected hidden>Select</option>
        <option value="view" className="color-options">View</option>
        <option value="edit" className="color-options">Edit</option>
      </Form.Select>
    )
  }

  function handleSelectChange(e, row) {
    if (e.target.value === "view") {
      // View = read-only itemized list (whole duration)
      navigate(`/statement-of-account/view/${row.id}`)
    } else if (e.target.value === "edit") {
      // Edit = itemized list with editable description + date range
      navigate(`/statement-of-account/edit/${row.id}`)
    }
  }

  async function fetchStatementsOfAccount() {
    setShowLoader(true)
    const response = await getStatementsOfAccount()
    // adjust the path below to match the backend response shape
    setData(response?.data?.data ?? [])
    setShowLoader(false)
  }

  useEffect(() => {
    fetchStatementsOfAccount()
  }, [])

  // filter by company / customer name / project name, then attach the action dropdown
  const q = searchText.trim().toLowerCase()
  const rows = data
    .filter((r) =>
      q === "" ||
      (r.company || "").toLowerCase().includes(q) ||
      (r.customer_name || "").toLowerCase().includes(q) ||
      (r.project_name || "").toLowerCase().includes(q)
    )
    .map((r) => ({ ...r, action_btn: ActionBtn(r) }))

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => setInactive(inactive)}
          active={"FINANCIAL REPORT"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={6}>
            <h1 className="page-title">Statement of Account</h1>
          </Col>
          <Col xs={6} className="d-flex justify-content-end">
            <input
              type="search"
              name="search"
              placeholder="Search"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              className="search-bar"
            />
          </Col>
        </Row>

        <div className="tab-content">
          <Table
            tableHeaders={["PROJECT NAME", "CUSTOMER NAME", "COMPANY", "ACTIONS"]}
            headerSelector={["project_name", "customer_name", "company", "action_btn"]}
            tableData={rows}
            showLoader={showLoader}
            withActionData={true}
            tableType="soa"
          />
        </div>
      </div>
    </div>
  )
}